module.exports = __webpack_public_path__ + "img/t2.0c77e108.png";